module.exports = __webpack_public_path__ + "static/media/bharathgourisetti.05979b44.png";